module.exports = __webpack_public_path__ + "img/active.818f115b.jpg";